"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var subpages_exports = {};
__export(subpages_exports, {
  SubpagesNode: () => SubpagesNode
});
module.exports = __toCommonJS(subpages_exports);
var import_core = require("@tiptap/core");
const SubpagesNode = import_core.Node.create({
  name: "subpages",
  group: "block",
  atom: true,
  draggable: true,
  selectable: true,
  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", (0, import_core.mergeAttributes)({ "data-type": this.name }, HTMLAttributes)];
  }
});
//# sourceMappingURL=subpages.js.map
